import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'napalm-v2-theme';

const SiteRefreshThemeContext = createContext();

export const SiteRefreshThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === 'light' ? 'light' : 'dark';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
  };

  return (
    <SiteRefreshThemeContext.Provider value={{ theme, toggleTheme, isDark: theme === 'dark' }}>
      {children}
    </SiteRefreshThemeContext.Provider>
  );
};

export const useSiteRefreshTheme = () => {
  const context = useContext(SiteRefreshThemeContext);
  if (!context) {
    throw new Error('useSiteRefreshTheme must be used within SiteRefreshThemeProvider');
  }
  return context;
};
